<template>
  <div
    :class="`
      subpage-header-component
      ${is_sticky
        ? 'subpage-header-component-sticky'
        : 'subpage-header-component-relative'
      }
    `"
    :style="`background-color:${background_color}`"
  >
    <div class="subpage-header-component-content">
      <!-- BACK BUTTON -->
      <BackButton
        v-if="!is_create_screen && !on_site"
        class="subpage-header-component-content-back"
        :background_color="background_color"
        :foreground_color="foreground_color"
        @backBtnClicked="$emit('backBtnClicked')"
      >
        <template #text>
          <TText
            value="back"
            :color="foreground_color"
            :size="14"
            style="padding-right: 14px"
          />
        </template>
      </BackButton>

      <!-- CANCEL/SAVE BUTTON -->
      <div v-if="is_create_screen" class="subpage-header-component-content-create">
        <ButtonOutlined
          class="subpage-header-component-content-create-button"
          icon="bin"
          :text="$t('Buttons.Cancel')"
          :color="foreground_color"
          @buttonClicked="$emit('cancelBtnClicked')"
        />
        <ButtonOutlined
          class="subpage-header-component-content-create-button"
          icon="floppy-disc"
          :text="$t('Buttons.Save')"
          :color="foreground_color"
          :loading="save_btn_loading"
          @buttonClicked="$emit('saveBtnClicked')"
        />
      </div>

      <!-- CENTER -->
      <div class="subpage-header-component-center">
        <slot name="center"/>
      </div>
      <!-- RIGHT SIDE -->
      <div
        class="subpage-header-component-right-side"
        :style="`justify-content: ${right_side_flex_align || 'flex-end'};`"
      >
        <slot name="rightside" />
      </div>
    </div>
    <slot name="below" />
  </div>
</template>

<script>
import BackButton from '@/components/WorkPackageWIP/BackButton.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';

  export default {
    components: {
      BackButton,
      TText,
      ButtonOutlined,
    },

    props: [
      'right_side_flex_align', // is string, contains justify-content string for right side
      'is_sticky', // is boolean, determins css position attribute and padding
      'is_create_screen', // is boolean, removes back button, activates save/cancel
      'background_color', // is string, contains hexadecimal value of background
      'foreground_color', // is string, contains hexadecimal value of text, outlines etc.
      'header_icon',
      'header_text',
      'save_btn_loading',
      'on_site',
    ],

    data: () => ({

    }),
  }
</script>

<style>
  .subpage-header-component {
    top: 0;
    z-index: 1;
    padding: 0px 10px 10px 10px;
    /* grid-gap: 10px; */
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .subpage-header-component-relative {
    position: relative;
    padding: 0px 0px 10px 0px;
  }
  .subpage-header-component-sticky {
    position: sticky;
    padding: 10px 0px;
  }
  .subpage-header-component-content {
    display: flex;
    /* align-items: flex-start; */
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    z-index: 20;
  }
  .subpage-header-component-content-back {
    flex-grow: 0;
    flex-shrink: 0;
    z-index: 100;
  }
  .subpage-header-component-center {
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    width: 100%;
  }
  .subpage-header-component-content-create {
    display: flex;
    justify-content: flex-start;
    grid-gap: 8px;
    width: 100%;
  }
  .subpage-header-component-content-create-button {
    flex-grow: 1;
  }
  .subpage-header-component-right-side {
    display: flex;
    flex-grow: 1;
    align-items: center;
  }
  .subpage-header-component-label {
    display: flex;
    grid-gap: 8px;
    margin: 0 8px;
  }
</style>
